import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModificationCenter } from '../Programs/v2/ModificationCenter';
import { UploadModificationButton } from './UploadModificationButton';
// The Modifications tab IS the review surface now (no /v2 hop): upload a mod,
// then review the extracted change-set inline — grouped by CLIN, before→after
// per change, resolve + commit. ModificationCenter renders the change-set
// roster + the grouped diff; we just add the upload affordance above it.
export function ModificationsTab({ programId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-muted-foreground",
                        children: "Upload a modification (SF30) and it's extracted into a reviewable change-set below — grouped by CLIN, with before→after for each change. Resolve each item, then commit to apply it to the contract."
                    }),
                    /*#__PURE__*/ _jsx(UploadModificationButton, {
                        programId: programId
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModificationCenter, {
                programId: programId
            })
        ]
    });
}
